// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__285Vk","icon":"SortAdornment_icon__3gCun","up":"SortAdornment_up__1QaN5","down":"SortAdornment_down__fp3mS","active":"SortAdornment_active__nepwJ"};